import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { PassCode } from '../Component.js';
import 'classnames';
import '../../../gap/esm';
import '../../../shared/esm';
import '../components/InputProgress/Component.js';
import 'react-transition-group';
import '../components/InputProgress/useInputProgress.js';
import '../components/KeyPad/Component.js';
import '@alfalab/icons-glyph/BackspaceXxlIcon';
import '../components/KeyPadButton/Component.js';
import '../../../button/esm/mobile';

var styles = {"component":"pass-code__component_lb5a9"};
require('./mobile.css');

var PassCodeMobile = forwardRef(function (restProps, ref) { return (React.createElement(PassCode, __assign({}, restProps, { ref: ref, styles: styles }))); });

export { PassCodeMobile };
